module.exports = __webpack_public_path__ + "img/icon01.15028e77.png";